import styles from "./categories-skin-4.module.css";
import { useCategories } from "../../categories.hook";
import { useEffect, useMemo } from "react";
import { resizeImage } from "@commons-monorepo/index";
import WidgetContainer from "../../../widget-container";
import { UiButton } from "@ui-monorepo/components";
import { ITheme } from "@commons-monorepo/index";

const CategoriesSkin4 = () => {
  const { categories: allCategories, partnerId, theme } = useCategories(5);

  const categories = useMemo(() => {
    return Array.isArray(allCategories) ?
    [...allCategories].map((category, index) => {
      if (category.className.includes("view-more")) {
        category.image = allCategories[index - 1].image;
      }
      return category;
    }) :
    [];
  }, [allCategories]);

  const imageStyle = (category: any) => {
    switch (partnerId) {
      case "bycarocastro":
        return {
          background: category.className.includes("view-more") ?
          `linear-gradient(rgba(0, 0, 0, 0.09), rgba(0, 0, 0, 0.55)), url(${resizeImage(category.image, 0, 0, 60)})` :
          `url(${resizeImage(category.image, 0, 0, 60)})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center"
        };
      default:
        return {
          background: category.className.includes("view-more") ?
          `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.84)), url(${resizeImage(category.image, 0, 0, 60)})` :
          `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url(${resizeImage(category.image, 0, 0, 60)})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center"
        };
    }
  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      withoutPadding>

      <div
        className={`${styles.categoriesSkin4Container} ${
        styles[`categoriesSkin4ContainerLayout${categories.length}`]
        } ${styles[`categoriesSkin4Container${categories.length % 2 === 0 ? "Par" : "Impar"}`]}`}>

        {categories.map((category: any, index: number) =>
        <div
          onClick={category.onClick}
          key={`key-${index}`}
          className={`${
          category.className.includes("view-more") ?
          `${styles.category} ${styles.viewMore}` :
          styles[category.className]
          }`}>

            <span>{category.name}</span>
            <div
            className={`${
            category.className.includes("view-more") ? `${styles.image} ${styles.viewMoreImage}` : styles.image
            }`}
            style={imageStyle(category)}>

              {!category.className.includes("view-more") &&
            <div className={styles.viewMoreButtonBox}>
                  <UiButton
                appearance='icon'
                className={styles.viewMoreButton}
                leftIcon={<div className='icon-arrow-right' />}
                theme={theme} />

                </div>}

            </div>
          </div>
        )}
      </div>
    </WidgetContainer>);

};

export default CategoriesSkin4;